import {BASE_URL} from '../constants/SystemConstants';


export const HEATING_URL= BASE_URL + 'heating';
export const HEATING_GET= 'HEATING_GET';